// src/components/HowItWorks.js (Consolidated Icons)

import React from 'react';
import { motion } from 'framer-motion'; // <-- Framer Motion Import
import HowItWorksStep from './HowItWorksStep';
import './HowItWorks.css'; 

// =======================================
// INLINE SVG ICON DEFINITIONS (No change)
// =======================================

const TargetIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon target-icon"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const SearchIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon search-icon"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const GrowthIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon growth-icon"
  >
    <path d="M12 20V10" />
    <path d="M18 20V4" />
    <path d="M6 20v-4" />
  </svg>
);

// =======================================
// FRAMER MOTION VARIANTS (Parent Container - SLOWED)
// =======================================
const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      // Slower delay before the first child starts
      delayChildren: 0.4, 
      // Slower time gap between each child's animation start
      staggerChildren: 0.25, 
    }
  }
};

// =======================================
// STEPS DATA AND MAIN COMPONENT
// =======================================

const stepsData = [
  {
    stepNumber: 1,
    icon: TargetIcon, 
    title: 'Define Your Aspiration',
    description: 'Tell us your career goal, current experience level, and available time commitment in a quick, guided flow.',
  },
  {
    stepNumber: 2,
    icon: SearchIcon, 
    title: 'Get Curated Resources',
    description: 'Our personalization engine instantly filters through thousands of resources to deliver only the content relevant to you.',
  },
  {
    stepNumber: 3,
    icon: GrowthIcon, 
    title: 'Learn, Track, and Grow',
    description: 'Access videos, articles, and tools, save your favorites, and follow a clear, personalized learning path.',
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works section-padding">
      <h2 className="section-heading">How Blue Print Works</h2>
      
      <motion.div 
        className="steps-container"
        variants={container}        // Pass the container object
        initial="hidden"           // Start hidden
        whileInView="visible"      // Animate to visible when scrolled into view
        viewport={{ once: true, amount: 0.4 }} // Trigger when 40% of the element is visible
      >
        {stepsData.map((step) => (
          <HowItWorksStep
            key={step.stepNumber}
            stepNumber={step.stepNumber}
            icon={step.icon} 
            title={step.title}
            description={step.description}
          />
        ))}
      </motion.div>
    </section>
  );
};

export default HowItWorks;